import {
  border,
  BorderProps,
  compose,
  css,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { Heading, mdBumps, smBumps } from '../atoms'
import { withDefaultProps } from '../defaultProps'
import { transition, TransitionProps } from '../transition'

export type FormBuilderSectionProperty = 'default' | 'nested'

export type FormBuilderSectionProps = BorderProps &
  FlexboxProps &
  GridProps &
  LayoutProps &
  PositionProps &
  PropsWithChildren &
  SpaceProps &
  TransitionProps & {
    variant?: FormBuilderSectionProperty
  }

const defaultProps = withDefaultProps<FormBuilderSectionProps>({
  variant: 'default',
})

export const FormBuilderSection = styled.div.attrs(defaultProps)<FormBuilderSectionProps>(
  css({
    display: 'flex',
    flexDirection: 'column',
  }),
  ({ theme }) =>
    variant({
      scale: 'FormBuilderSection',
      variants: {
        default: {
          rowGap: mdBumps,
        },
        nested: {
          rowGap: smBumps,
          [Heading]: {
            fontSize: theme.typoSizes.base.fontSize,
            lineHeight: theme.typoSizes.base.lineHeight,
          },
        },
      },
    }),
  compose(border, flexbox, grid, layout, position, space, transition),
)
